import { Component } from '@angular/core';
import { ActionResult } from '@ntap/core';
import { PrimeNGButtonOpenItemViewActionComponent } from '@ntap/primeng';
import { first, map, mergeMap, Observable, tap } from 'rxjs';

@Component({
  selector: 'app-edit-obrazac-upisa-action',
  templateUrl: '../../../shared/components/actions/common-action-template.html'
})
export class EditObrazacUpisaActionComponent extends PrimeNGButtonOpenItemViewActionComponent {
  protected override doChangedInputParam(): void {
    super.doChangedInputParam();
    this.initDisabledObservable(); // ne znam zasto ovo treba zvati zasebno, ali inace se ne updejta state
  }

  // overridano da ne validiramo formu na execute
  protected override doExecute(): Observable<ActionResult> {
    return this.itemProvider.item$.pipe(
      first(), // ItemAction should process only 1 item
      mergeMap((item) => this.doExecuteWithItem(item)),
      tap((result) => this.updateItem(result)),
      map((result) => result.result)
    );
  }

  protected override initDisabledObservable(): void {
    this.isDisabled$ = this.action$.pipe(map((a) => a.disabled));
  }
}
